import { analysisRequest } from 'api/analysisRequest'

export const getWebResultCndpSkin = async (id: string) =>
	await analysisRequest(`web-result/cndpskin/${id}`)
